import React from 'react';
import {
  Zap,
  RefreshCw,
  Building2,
  BarChart3,
  KeyRound,
  Workflow,
  GitBranch,
  Bell,
  Layers,
  Sparkles,
  Stethoscope,
  Code2,
} from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { platformCapabilities } from '../data/overview';

const capabilityIcons = [
  Zap,
  RefreshCw,
  Building2,
  BarChart3,
  KeyRound,
  Workflow,
  GitBranch,
  Bell,
  Layers,
  Sparkles,
  Stethoscope,
  Code2,
] as const;

export const PlatformCapabilities: React.FC = () => (
  <SiteSection className="platform-capabilities-section">
    <SiteSectionHeader
      title="Platform Capabilities"
      subtitle="Enterprise features built for connected product teams"
      align="center"
    />
    <div className="platform-caps">
      {platformCapabilities.map((cap, i) => {
        const Icon = capabilityIcons[i] ?? Zap;
        return (
          <article key={cap.id} className="platform-cap">
            <div className="platform-cap__icon" aria-hidden>
              <Icon className="platform-cap__icon-svg" strokeWidth={1.75} />
            </div>
            <h3 className="platform-cap__label">{cap.label}</h3>
          </article>
        );
      })}
    </div>
  </SiteSection>
);
